export default {"src":"/_next/static/media/tear-off_calendar_color.eb494528.svg","height":32,"width":32};